<template>
  <section class="cta-area d-ldark-bg pt-55 pb-10">
      <div class="container">
          <div class="row">
              <div class="col-lg-6 col-md-6">
                  <div class="cta-item cta-item-d mb-30">
                      <h5 class="cta-title">Follow Us</h5>
                      <p>We make consolidating, marketing and tracking your social media website easy.</p>
                      <div class="cta-social">
                          <div class="social-icon">
                              <a href="https://www.facebook.com/share/1MgFXbRzki/" target="_blank" class="facebook"><i class="fab fa-facebook-f"></i></a>
                              <a href="#" target="_blank" class="twitter"><i class="fab fa-x"></i></a>
                              <a href="#" target="_blank" class="youtube"><i class="fab fa-youtube"></i></a>
                              <a href="#" target="_blank" class="linkedin"><i class="fab fa-whatsapp"></i></a>
                              <a href="https://www.tiktok.com/@kzonemobi?_t=ZS-8u0euPrgDfG&_r=1" class="tiktok"><i class="fab fa-tiktok"></i></a>
                              
                          </div>
                      </div>
                  </div>
              </div>
              <div class="col-lg-6 col-md-6">
                  <div class="cta-item mb-30">
                      <h5 class="cta-title">Sign Up To Newsletter</h5>
                      <p>Join 60.000+ subscribers and get a new discount coupon  on every Saturday.</p>
                      <div class="subscribe__form">
                          <form action="#">
                              <input type="email" placeholder="Enter your email here...">
                              <button>subscribe</button>
                          </form>
                      </div>
                  </div>
              </div>
             
          </div>
      </div>
  </section>
</template>

<script>

</script>
